export const ACTION_LOAD_PRODUCT = 'LOAD_PRODUCT';
